import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpMisStatusReportPage } from '@/features/pcmp/pages/PcmpMisStatusReportPage';
import { pcmpMisStatusReportSearchSchema } from '@/features/pcmp/types/pcmpMisStatusReport.types';

export const Route = createFileRoute('/_auth/pcmp/reports/mis-status/')({
  validateSearch: pcmpMisStatusReportSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP MIS Status Report">
      <Suspense fallback={<PageLoader />}>
        <PcmpMisStatusReportPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
